import { abyssColors } from '@/theme/colors';
import { Box, TextField, Typography, styled as muiStyled } from '@mui/material';

interface CaptionBoxProps {
  fluid?: boolean;
}

export const CaptionBox = muiStyled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  width: '100%',
}));

export const CaptionTextField = muiStyled(TextField)<CaptionBoxProps>(({ fluid }) => ({
  padding: 0,
  margin: 0,
  '& .MuiOutlinedInput-root': {
    padding: '0 8px',
    fontSize: '1.2rem',
    fontFamily: 'Roboto',
    fontWeight: 400,
    lineHeight: '14.06px',
    borderRadius: '6px',
    minWidth: '7rem',
    maxWidth: fluid ? '100%' : '7rem',
    outline: 'none',
    background: 'transparent',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    transition: 'width 0.1s',
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #E0E0E0',
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '4px 0',
    minWidth: 40,
    width: '100%',
    maxHeight: 120,
    overflowY: 'auto',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  '& .MuiFormHelperText-root': {
    textAlign: 'center',
    margin: '2px 0 0 0',
  },
}));
export const ImageCaption = muiStyled(Typography)<CaptionBoxProps>(({ fluid }) => ({
  textAlign: 'center',
  fontWeight: 400,
  fontSize: '1.2rem',
  cursor: 'pointer',
  color: abyssColors.primary[400],
  maxWidth: fluid ? '100%' : '7rem',
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  whiteSpace: 'normal',
  textOverflow: 'ellipsis',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
}));
